import { ChangeDetectionStrategy, Component, computed, inject, OnDestroy, OnInit, signal } from '@angular/core';
import { Router } from '@angular/router';
import { CacheService } from '@services/cache';
import { LogsService } from '@services/logs';
import { ButtonComponent } from '@shared/components/button';
import { TitleComponent } from '@shared/components/title';
import { Title } from '@shared/components/title/model';

@Component({
  selector: 'app-form-layout-3-success',
  templateUrl: './form-layout-3-success.component.html',
  styleUrl: './form-layout-3-success.component.scss',
  imports: [TitleComponent, ButtonComponent],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FormLayout3SuccessComponent implements OnInit, OnDestroy {
  requestType = signal<string>('');
  readonly title = computed<Title>(() => {
    return {
      level: 'H1',
      text: `Votre demande a bien été ${this.requestType() === 'SAV' ? 'prise en compte.' : 'envoyée !'}`,
      color: 'WHITE',
      align: {
        mobile: 'LEFT',
        desktop: 'LEFT',
      },
      size: {
        mobile: 'H1',
        desktop: 'H1',
      },
    };
  });
  storeName = signal<string>('');
  dataLoaded = signal(false);

  message = computed(() => {
    const type = this.requestType();
    const store = this.storeName();

    const delay = type === 'SAV' ? 'dans un délai de 48h' : 'dans les meilleurs délais';

    if (type === 'SAV' || type === 'COMMANDE') {
      const trustedEntity = store ? `notre boutique Perene ${store}` : 'Perene';
      return `Nous vous remercions d'avoir fait confiance à ${trustedEntity}. Nous revenons vers vous ${delay}.`;
    }

    return `Nous vous remercions d'avoir pris contact avec nous et revenons vers vous prochainement${delay}.`;
  });

  #cacheService = inject(CacheService);
  #router = inject(Router);
  readonly #logsService = inject(LogsService);

  ngOnInit(): void {
    void this.#cacheService
      .get('form-layout-3')
      .then((dataCache) => {
        if (dataCache === null) {
          this.redirectToForm();
        } else {
          const data = dataCache as { requestType: string; storeName: string };
          this.requestType.set(data.requestType ?? '');
          this.storeName.set(data.storeName ?? '');
          this.dataLoaded.set(true);
        }
      })
      .catch((error: unknown) => {
        this.#logsService.error('FormLayout3SuccessComponent', 'Failed to read contact recap from cache', error);
        this.redirectToForm();
      });
  }

  ngOnDestroy(): void {
    void this.#cacheService.remove('form-layout-3');
  }

  private redirectToForm() {
    const urlSegments = this.#router.url.split('/');
    const newUrl = `/${urlSegments[1]}`;
    void this.#router.navigateByUrl(newUrl);
  }
}
